<template>
  <div class="container">


    <div class="row">
      <div class="col 2-col">
        <h2 id="climate">4. Climate</h2>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3>4.1. Precipitation</h3>
        <div class="row">
          <div class="col-7">
            <ImageMap 
              title="Precipitation" 
              v-bind:images="[{title:'Precipitation',source:'/mountain_climate/Precipitation.png'}]" 
              v-bind:location="location"
              v-bind:factsheet="factsheet" 
              v-bind:loaded="loaded"
              attribution="Data: GloH2O Climate Classification Maps.">
            </ImageMap>
          </div>
          <div class="col col-5">
            <Figure 
              title="Monthly Precipitation"
              src="mountain_climate/PrecipitationMonthly.svg"
              label="Monthly average temperature" 
              attribution="Data: GloH2O PBCOR/CHELSA"

              v-bind:location="location"
              v-bind:factsheet="factsheet" 
              v-bind:loaded="loaded"
              >
            </Figure>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3>4.2. Temperature</h3>
        <div class="row">
          <div class="col-7">
            <ImageMap 
              title="Temperature" 
              v-bind:images="[{title:'Temperature',source:'/mountain_climate/Temperature.png'}]" 
              v-bind:location="location"
              v-bind:factsheet="factsheet" 
              v-bind:loaded="loaded"
              attribution="Data: CHELSA">
            </ImageMap>
          </div>
          <div class="col col-5">
            <Figure 
              title="Monthly Temparature" 
              src="mountain_climate/TemperatureMonthly.svg"
              label="Monthly average temperature" 
              attribution="Data: CHELSA"

              v-bind:location="location"
              v-bind:factsheet="factsheet" 
              v-bind:loaded="loaded"
              >
            </Figure>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3>4.3. Current and Future Climate Classifications</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <ImageMap 
          title="Current Climate Classifications" 
          v-bind:images="[{title:'Current Climate Classification',source:'/mountain_climate/ClimateClassificationsCurrent.png'}]" 
          v-bind:location="location"
          v-bind:factsheet="factsheet" 
          v-bind:loaded="loaded"
          attribution="Data: GloH2O Climate Classification Maps.">
            
        </ImageMap>
      </div>
      <div class="col">
        <ImageMap 
          title="Future Climate Classifications" 
          v-bind:images="[{title:'Current Climate Classification',source:'/mountain_climate/ClimateClassificationsFuture.png'}]" 
          v-bind:location="location"
          v-bind:factsheet="factsheet" 
          v-bind:loaded="loaded"
          attribution="Data: GloH2O Climate Classification Maps.">
            
        </ImageMap>
      </div>

    </div>
  </div>
</template>

<script>
    /* eslint-disable */
    import ImageMap from '@/components/factsheet/maps/ImageMap.vue'
    import Figure from '@/components/factsheet/Figure.vue'

    import _ from 'lodash';

    export default {
        name: 'Climate',
        components: { ImageMap, Figure },
        props: ['location', 'factsheet', 'loaded'],
        data() {
            return {
            }
        },
        created() {
        },
        computed: {
        },
        mounted() {
        },
        filters: {
          percent: function (value) {
            return value.toFixed(1)+'%'
          }
        },
        methods: {
          urlFor(asset) {
            return process.env.VUE_APP_API+'/api/data/factsheet/'+this.factsheet.info.identifier+'/data/'+asset;
          },
          andList(list, attr, attrpercent) {
            var ret = ""
            for(var i=0; i<list.length;i++) {
              var percent = attrpercent ? ' ('+list[i][attrpercent]+'%)' : ''
              if (list.length == 1) {
                return list[i][attr]+percent
              }
              if(i == list.length-1) {
                ret += " and "+list[i][attr]+percent
              } else {
                ret += list[i][attr]+percent+", "
              }
            }
            return ret
          }
        }
    }
</script>

<style>
div.map {
    width:100%;
    height:450px;
    display:block;
}
</style>

<style scoped>

caption {
  caption-side: top;
  font-weight:bold;
  font-size:1em;
  padding:5px;
  color:rgb(33, 37, 41);
  padding-left:0px;
}
table {
   font-size:0.75em;
}
table th, table td {
  padding-left:0px;
}

</style>